export default __webpack_public_path__ + "static/media/cff58faa8942fe6f.60d78dfa5f857dd2395b2fdf20f1a32f.svg";